import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AIAgentPreferences, AIAgentPreferencesUpdate } from '../interfaces/agent-preferences.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({ providedIn: 'root' })
export class AgentUserPreferencesService {
    private readonly _ajaxService = inject(AjaxService);

    private readonly _urlsService = inject(UrlsService);

    get(): Observable<AIAgentPreferences> {
        return this._ajaxService.getDataObserveBody<AIAgentPreferences>(this._urlsService.AGENT.PREFERENCES);
    }

    save(preferences: AIAgentPreferencesUpdate): Observable<void> {
        return this._ajaxService.postDataObserveBody<void>(this._urlsService.AGENT.PREFERENCES, preferences);
    }
}
